import { endpoint } from './endpoint.js';
import {
  SupplierPhotoManifestRequestSchema,
  SupplierPhotoManifestResponseSchema,
} from '../schemas/supplier-photo-manifest.js';

export const supplierPhotoDownload = {
  manifest: endpoint(
    'POST',
    '/media-units/photos/supplier-zip-manifest',
    SupplierPhotoManifestRequestSchema,
    SupplierPhotoManifestResponseSchema,
  ),
};
